import { render, staticRenderFns } from "./D005.vue?vue&type=template&id=90627a72&scoped=true&"
import script from "./D005.vue?vue&type=script&lang=js&"
export * from "./D005.vue?vue&type=script&lang=js&"
import style0 from "./D005.vue?vue&type=style&index=0&id=90627a72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90627a72",
  null
  
)

export default component.exports